var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record-vehicle loading-content-container" },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "8" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c("csp-desktop-vehicle-basedata", {
                            attrs: {
                              "form-context":
                                _vm.initialFormContexts.vehicleBasedata,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: 4 } },
                    [
                      _c(
                        "b-row",
                        [
                          _vm.canShowGallery
                            ? _c(
                                "csp-desktop-info-card",
                                {
                                  attrs: {
                                    cols: 12,
                                    icon: "inticon-documents",
                                    title: "Fahrzeugdokumente / -bilder",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "loading-content-container",
                                    },
                                    [
                                      _vm.galleryIsLoading
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "loading-overlay d-flex justify-content-center",
                                            },
                                            [_c("csp-loading-indicator")],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.galleryIsLoading
                                        ? _c(
                                            "div",
                                            [
                                              _vm.galleryFiles.length > 0 &&
                                              _vm.galleryActiveIndex != null
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "preview collapse-body mb-5",
                                                      staticStyle: {
                                                        height: "450px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                _vm.galleryActiveTitle,
                                                              expression:
                                                                "galleryActiveTitle",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "galleryActiveTitle text-center mb-4",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                        " +
                                                              _vm._s(
                                                                _vm.galleryActiveTitle
                                                              ) +
                                                              "\n                                    "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("csp-file-gallery", {
                                                        attrs: {
                                                          "active-index":
                                                            _vm.galleryActiveIndex,
                                                          files:
                                                            _vm.galleryFiles,
                                                          height: 400,
                                                          width: 400 / 1.414,
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.onGalleryChange,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.galleryFiles.length == 0
                                                ? _c(
                                                    "b-alert",
                                                    {
                                                      attrs: {
                                                        show: "",
                                                        variant: "info",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                    Keine Fahrzeugdokumente oder -bilder vorhanden.\n                                "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }